import { DateOrderPipe } from './date-order.pipe';

export const UI_PIPES = [DateOrderPipe];

export * from './date-order.pipe';
